import React from 'react'

export default () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
  >
    <circle fillRule="evenodd" clipRule="evenOdd" cx="200" cy="200" r="200" />
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenOdd"
        fill="#ffffff"
        d="M316,199l-66.7-66.4v48.6l-66.2,48.7l66.2,0v35.5L316,199z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenOdd"
        fill="#ffffff"
        d="M81,199l66.7,66.4v-48.3l66.2-49.1l-66.2,0v-35.5L81,199z"
      />
    </g>
  </svg>
)
